<script lang="ts">
  import Card from "../tournament-team-card/index.svelte";
  // import Filter from "./filter/index.svelte";
  import ImageComp from "$components/image.svelte";
  import Trustpilot from "$components/trustpilot/testimonials/slider.svelte";
  import TrustpilotMob from "$components/trustpilot/starter.svelte";
  import HalfBanner from "../half-banner/index.svelte";
  import LastBought from "$components/last-bougth/index.svelte";
  import BreadCrumbs from "../breadcrumb/index.svelte";
  import ContentSlider from "../content-slider/index.svelte";
  import ListNotFound from "$components/list-not-found/index.svelte";

  export let data;

  $: ({ results, locale } = data);
  $: ({ content, title, slug, attributes, events } = results);
  $: paths = [
    { url: "/", name: "home" },
    { url: "/teams", name: "teams" },
    { url: `/teams${slug}`, name: `${title} Tickets` },
  ];

  let bgColour = attributes?.colour || "";
  if (bgColour !== "") {
    bgColour = `background-color:${bgColour}20`;
  }

  function makeBgColour(colour?: string) {
    if (colour) {
      return `background-color:${colour.trim()}20`;
    }
    return "";
  }

  let mobileVisible = 7;
  function loadMore(ev: Event) {
    ev.stopImmediatePropagation();
    mobileVisible += 8;
  }

  function updateSeason() {
    const date = new Date();
    const year = date.getFullYear();

    // Fixed cutoff: June 30 of the current year
    const cutoffDate = new Date(year, 5, 15); // month is 0-based, so 5 = June and 15 is the day

    if (date > cutoffDate) {
      // After June 30 → season starts current year
      return `${year}/${(year + 1).toString().slice(-2)}`;
    } else {
      // On or before June 30 → season started last year
      return `${year - 1}/${year.toString().slice(-2)}`;
    }
  }
</script>

<div class="content-grid">
  <div class="breadcrumb full-width" style={makeBgColour(attributes?.colour)}>
    <div class="inner grid">
      <div class="image desk-only">
        <ImageComp image={attributes?.logo} className="club-logo" />
      </div>
      <BreadCrumbs {paths}>
        <div class="image mob-only">
          <ImageComp image={attributes?.logo} className="club-logo" />
        </div>
        <div class="title-container">
          <h1 class="sf-700">{title} Tickets</h1>
          {#if data?.results?.lastSold}
            <div class="last-wrap">
              <LastBought lastSold={data.results.lastSold} className={"desk-only"} />
            </div>
          {/if}
        </div>
      </BreadCrumbs>
    </div>
  </div>

  <div class="teams-wrapper desk-only">
    <div class="teams-content grid">
      <div class="content grid generic-content">
        <ContentSlider {content} />
      </div>
      <div class="half-banner">
        <HalfBanner />
      </div>
    </div>
  </div>
  <div class="page-data grid">
    <!-- ev -->
    <div class="events-list">
      <div class="head grid">
        <h3 class="sf-700">{title} Fixtures {updateSeason()}</h3>
        <!-- <div>
          <Filter bind:events={results.events} />

        </div> -->
      </div>

      <div class="full-list">
        {#if events?.length}
          {#each events as event, i}
            <Card {event} {locale} className={i > mobileVisible ? "desk-only" : ""} />
          {/each}
        {:else}
          <ListNotFound message={`At the moment, there are no tickets available for ${title} team...`} />
        {/if}
      </div>
      {#if mobileVisible < events.length}
        <button class="mob-only load-more" on:click={loadMore}>Load More</button>
      {/if}
    </div>
  </div>

  <div class="trustpilot">
    <div class="desk-only">
      <h5>Trusted by thousands of fans</h5>
      <Trustpilot theme="light" className={""} />
    </div>
    <TrustpilotMob theme="light" className={"mob-only"} height="110px" />
  </div>
  <div class="bottom-content grid">
    {#if results?.contentList}
      {#each results.contentList as item}
        <div class="col1">{@html item}</div>
      {/each}
    {/if}
  </div>
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .content-grid {
    background: #fff;
    @include desktop {
      background: var(--background-color);
      margin-bottom: 120px; // Standard margin bottom before footer
    }
  }

  .breadcrumb {
    height: 8.75em;
    align-content: center;
    .inner {
      padding: 1em;
      text-align: center;
      gap: 0.5em;
      @include desktop {
        padding: 2.25em 0;
        gap: 1em;
        grid-template-columns: 2.75em 1fr;
        text-align: left;
      }

      .title-container {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.3em;
        position: relative;
        @include desktop {
          margin-bottom: 0.5em;
          justify-content: space-between;
        }

        .last-wrap {
          position: absolute;
          right: 2em;
          top: -0.2em;
        }
      }

      h1 {
        font-size: 1.25em;
        line-height: 30px;
        margin: 0;
        @include desktop {
          font-size: 1.85em;
        }
      }

      .image {
        width: 40px;
        margin: auto;
        @include desktop {
          margin: unset;
          width: 2.75em;
          margin-top: 0.25em;
        }
      }
    }
  }

  .teams-wrapper {
    margin: 4.375em 0;

    .teams-content {
      .content {
        grid-template-columns: 1fr;
        line-height: 1.5625em;
      }
    }
  }

  .page-data {
    margin: 1.25em 0;
    padding: 1.25em 0;
    @include desktop {
      padding: 0;
      margin: 0;
      margin-bottom: 100px;
    }

    .events-list {
      .head {
        display: grid;
        grid-template-columns: auto 2.8em;
        align-items: center;
        gap: 0;
        padding-bottom: 1.25em;

        h3 {
          margin: 0;
          font-size: 1.25em;
          @include desktop {
            font-size: 2.25em;
          }
        }
      }

      .full-list {
        display: grid;
        gap: 0.625em 1em;

        @include desktop {
          grid-template-columns: 1fr;
        }
      }
    }
  }

  .trustpilot {
    background: #f8f8f8;
    padding: 35px 1em;
    margin-bottom: 1.25em;
    border-radius: 5px;
    display: flex;
    place-items: center;
    :global(> div) {
      width: 100%;
    }

    @include desktop {
      background: #f4f4f4;
      margin-bottom: 0;
      border-radius: 0;
    }

    .desk-only {
      h5 {
        color: #000;
        font-family: Nunito;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 30px; /* 150% */
        text-align: center;
        margin-bottom: 40px;
      }
    }
  }

  .bottom-content {
    padding: 1.25em 1.5em;
    background: #f8f8f8;
    border-radius: 5px;
    margin: 20px 0 40px;

    @include desktop {
      margin-top: 100px;
      padding: 0;
      background: 0;
      border-radius: 0;
    }
  }

  .load-more {
    margin-top: 20px;
    height: 44px;
    padding: 0;
  }
</style>
